<div class="border border-neutral-3 rounded-2xl p-4 flex flex-col gap-3 bg-neutral-1/50">
  <div class="flex items-center justify-between">
    <div>
      <span class="text-xs font-extrabold text-neutral-10 uppercase tracking-wider block">
        {{ title() }}
      </span>
      <span class="text-[11px] text-neutral-9"> {{ subtitle() }} </span>
    </div>
    <span class="text-[11px] font-bold text-indigo-11 bg-indigo-a2 px-2 py-0.5 rounded-md">
      {{ services().length }} sélectionné{{ services().length > 1 ? 's' : '' }}
    </span>
  </div>

  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 mt-1">
    @for (srv of availableServices; track srv.key) {
      @let selected = isServiceSelected(srv.key);
      <button
        type="button"
        (click)="toggleService(srv.key)"
        class="flex items-start gap-2.5 p-2.5 rounded-xl border text-left transition-all cursor-pointer"
        [class.border-primary]="selected"
        [class.bg-primary-surface]="selected"
        [class.border-neutral-3]="!selected"
        [class.bg-white]="!selected"
        [class.dark:bg-neutral-2]="!selected"
      >
        <!-- Icon container with high contrast -->
        <div
          class="w-7 h-7 rounded-lg flex items-center justify-center shrink-0 transition-colors"
          [class.bg-primary]="selected"
          [class.bg-neutral-2]="!selected"
        >
          <mat-icon
            class="text-sm! w-4! h-4!"
            [class.!text-white]="selected"
            [class.!text-neutral-10]="!selected"
          >
            {{ srv.icon }}
          </mat-icon>
        </div>

        <div class="flex flex-col min-w-0 flex-1">
          <div class="flex items-center justify-between">
            <span
              class="text-xs font-semibold truncate leading-tight"
              [class.text-primary]="selected"
              [class.text-neutral-12]="!selected"
            >
              {{ srv.label }}
            </span>
            @if (selected) {
              <mat-icon class="text-xs! w-3.5! h-3.5! !text-primary shrink-0 ml-1">check</mat-icon>
            }
          </div>
          <span class="text-[10px] text-neutral-10 leading-snug mt-0.5 line-clamp-2">
            {{ srv.description }}
          </span>
        </div>
      </button>
    }
  </div>
</div>
